/* The catalog lives in an alternate collection view; retain it when Horizon serializes filters. */
(function () {
  if (window.__ligWinterShopTools) return;
  window.__ligWinterShopTools = true;
  document.addEventListener('formdata', function (event) {
    if (event.target instanceof HTMLFormElement && event.target.matches('[id^="FacetFiltersForm"]')) {
      event.formData.set('view', 'winter-shop');
    }
  }, true);
})();
